import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TwAforoCultivoCamViewModel } from './unidad-inspeccion-datosbasicos.types';
import { FilterSearchingTwAforoViewModel, AforoItemResultsViewModel, TwAforoViewModel } from '../../_mantenimiento/campanias/aforos/aforos.types';

@Injectable()
export class AforoCultivoCamService {
    private aforoCultivoCamEndpoint = this.baseUrl + 'api/campanias/aforoCultivoCam/';

    private lastSearch?: FilterSearchingTwAforoViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterSearchingTwAforoViewModel
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterSearchingTwAforoViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingTwAforoViewModel;

        for (k in payload) {
            //let v;
            //let valor = payload[k];

            let v = payload[k] || '';
            params = params.append(k, v);
        }

        return params;
    }

    /**
     * Invokes the service to get the list of "Aforos", applying the filter in the parameter
     * @param payload FilterSearchingTwAforoViewModel
     * @returns Observable<AforoItemResultsViewModel>
     */
    getAforos(payload: FilterSearchingTwAforoViewModel): Observable<AforoItemResultsViewModel> {
        this.lastSearch = { ...payload }; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getAforosPagedByFilter(params);
    }

    /**
     * Invokes the service to get the list of "Aforos", applying the filter in the parameter
     * @param params HttpParams
     * @returns Observable<AforoItemResultsViewModel>
     */
    private getAforosPagedByFilter(params: HttpParams): Observable<AforoItemResultsViewModel> {
        return this.http.get<AforoItemResultsViewModel>(this.aforoCultivoCamEndpoint + 'PagedByFilter/', { params: params });
    }

    getAforo(idAforoCultivo: number): Observable<TwAforoViewModel> {
        return this.http.get<TwAforoViewModel>(this.aforoCultivoCamEndpoint + idAforoCultivo);
    }

    getAforosByIdCultivo(idCultivo: number): Observable<TwAforoCultivoCamViewModel[]> {
        return this.http.get<TwAforoCultivoCamViewModel[]>(this.aforoCultivoCamEndpoint + 'list/' + idCultivo);
    }

    saveAforo(aforo: TwAforoCultivoCamViewModel): Observable<any> {
        if (aforo.Id) {
            return this.updateAforo(aforo);
        }
        return this.createAforo(aforo);
    }

    private createAforo(aforo: TwAforoCultivoCamViewModel): Observable<any> {
        return this.http.post<TwAforoCultivoCamViewModel>(this.aforoCultivoCamEndpoint, aforo);
    }

    private updateAforo(aforo: TwAforoCultivoCamViewModel): Observable<any> {
        return this.http.put<TwAforoCultivoCamViewModel>(this.aforoCultivoCamEndpoint, aforo);
    }

    deleteAforo(idAforo: number): Observable<any> {
        return this.http.delete<TwAforoCultivoCamViewModel>(this.aforoCultivoCamEndpoint + idAforo);
    }

    export(model: FilterSearchingTwAforoViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.aforoCultivoCamEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingTwAforoViewModel | undefined {
        return this.lastSearch;
    }

    resetFilter() {
        this.lastSearch = undefined;
    }
}
